module.exports = __webpack_public_path__ + "img/press.48e99fe.jpg";